import { Action, ActionReducer, INIT, MetaReducer } from '@ngrx/store';
import { authResetAction } from './auth.actions';

/**
 * MetaReducer to signal the store should be reset on user logout. Every federated app needs
 * to implement this in order to reset the store when the user logs out.
 *
 * Example:
 *   StoreModule.forFeature(MT_REPORTER_FEATURE_KEY, planningReducerMap, {
            metaReducers: authMetaReducer,
        }),
 * @param reducer
 * @returns
 */
export function logout(reducer: ActionReducer<Action>): ActionReducer<Action> {
    return (state, action) => {
        if (action !== null && action.type === authResetAction.type) {
            return reducer(undefined, { type: INIT });
        }
        return reducer(state, action);
    };
}

export const authMetaReducer: MetaReducer[] = [logout];
